
import CardImageTop from '@/components/CardImageTop.vue';
import { PackagePathSegment } from '@/models/package-path-segment';
import { Actions } from '@/store/actions';
import PriceUtil from '@/util/price-util';
import he from 'he';
import { computed, ComputedRef, defineComponent, PropType } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'PackagePathSegmentView',
  components: {CardImageTop},
  props: {
    segment: {
      type: Object as PropType<PackagePathSegment>,
      required: false,
      default: null
    }
  },
  setup(props) {
    const store = useStore();

    const displayPrice: ComputedRef<string> = computed(() => {
      if (!props.segment) {
        return '';
      }

      const price = props.segment?.price || props.segment?.options.reduce((
          pv,
          cv) => pv + cv.price, 0);

      return PriceUtil.formatGermanWithFractionsOptional(price);
    });

    function decodeHtmlEntities(input: string): string {
      return he.decode(he.decode(input));
    }

    function onClick(): boolean {
      store.dispatch(Actions.SelectPathSegment, props.segment);
      return false;
    }

    return {
      displayPrice,
      decodeHtmlEntities,
      onClick
    };
  }
});
